module.exports = {
	"env": "prod",
	"mongodb": "mongodb://172.10.2.181:27017/wdp",
	"mongodb_smpg": "mongodb://172.10.2.181:27017/smpg",
	"widgets": {
		"url": "https://widgets.tjekscores.dk",
		"port": 80
	},
	"assets": "https://cdn.tjekscores.dk/wdp/prod",
	"apis": {
		"ss2": "https://ss2.si-ab.com",
		"smpg": "https://smpg.tjekscores.dk",
		"@webshot": "http://wdp-webshot-prod-916696882.eu-west-1.elb.amazonaws.com",
		"@webshot2": "https://webshot-prod.tjekscores.dk",
		"webshot": "https://webshot-prod.tjekscores.dk",
		"ps": "https://ps.tjekscores.dk",
		"html2video": "https://html2video.tjekscores.dk"
	},
	"dash": {
		"api": {
			"port": 80,
			"host": "https://wdp.tjekscores.dk"
		}
	},
	"urls": {
		"publicPath": "https://cdn.tjekscores.dk/wdp/prod"
	},
	"campaign_manager": {
		"loggerKey": "b39a96b6-f436-4243-8aa0-b21ca2f0c6f4",
		"host": "https://cmp.tjekscores.dk",
		"port": 8011
	},
	"rabbitmq": {
		"@url": "amqp://rlz:admin@rabbit-prod-1023334297.eu-west-1.elb.amazonaws.com:5672",
		"url": "amqps://admin:adminadminadmin@b-8ea2cde3-dba5-496d-90a6-c7953532fb63.mq.eu-west-1.amazonaws.com:5671"
	},
	"bots": {
		"messenger": {
			"api": "http://social-bot-stage.tjekscores.dk"
		}
	},
	"stats_service": {
		"loggerKey": "a7dca39a-27a1-4307-b111-9970f89b563b"
	},
	"triggerer": {
		"loggerKey": "ff9598cd-0150-4955-9e49-4ad88b0e3291",
		"port": 80
	},
	"autoUpdateInterval": 30
};


/*****************
 ** WEBPACK FOOTER
 ** ../config/prod.json
 ** module id = 1299
 ** module chunks = 0 1
 **/